import { useQueryClient } from '@tanstack/react-query';
import { useCellPhoneLookupMutation } from '../../queries/CellPhoneLookup';
import type { ICellPhoneLookupResult } from '../../queries/CellPhoneLookup';
import { queryKeys } from './queryKeys';

export type UseFindCellPhoneArgs = {
	companyId: string | undefined;
	onSuccess?: (data: ICellPhoneLookupResult) => void;
	onError?: (error: Error) => void;
};

/**
 * Thin wrapper over `useCellPhoneLookupMutation` that invalidates the focused
 * view's contacts query on success — the mutation server-side may attach a
 * newly-found number to the contact, so the rail should re-fetch to surface it.
 *
 * The mutation result is also forwarded via `onSuccess` so the caller can show
 * a toast or open a modal with the matches; the focused view shows a toast
 * today (full add-to-contact picker is a followup).
 */
export function useFindCellPhone({ companyId, onSuccess, onError }: UseFindCellPhoneArgs) {
	const queryClient = useQueryClient();
	return useCellPhoneLookupMutation({
		onSuccess: data => {
			if (companyId) {
				queryClient.invalidateQueries({ queryKey: queryKeys.focusedView.contacts(companyId) });
			}
			onSuccess?.(data);
		},
		onError,
	});
}
